module.exports = __webpack_public_path__ + "static/media/KitaseoCovidAlcaldesa.12aee6f0.mp3";